/*
 * Created by Ali Simsek on 5/14/20, 2:02 PM
 * Copyright (c) 2020 Carla Car Rental, Inc. All rights reserved.
 * Last modified 5/13/20, 6:11 PM
 */

import React from 'react'

const DefaultOnSSR = <span />

class NoSSR extends React.Component {
  constructor(...args) {
    super(...args)
    this.state = {
      canRender: false
    }
  }

  componentDidMount() {
    this.setState({ canRender: true })
  }

  render() {
    const { children, onSSR = DefaultOnSSR } = this.props
    const { canRender } = this.state

    return canRender ? children : onSSR
  }
}

export default NoSSR
